window.addEventListener('load', function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.getAttribute('href') == '#manage-cookies') {
        tarteaucitron.userInterface.openPanel();
      } else {      
        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
	});
});